// services/baseApiService.js
import axios from 'axios';

// Use the environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Utility function to construct full image URLs
export const getFullImageUrl = (relativePath) => {
  if (!relativePath) return null;
  return `${API_BASE_URL}${relativePath}`;
};

// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If the error is due to an unauthorized request, remove the token and reject∆
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

export default api;
